<app-filtros-reporte>
  <form class="space-y-3 sm:space-y-4" (submit)="aplicarFiltros($event)">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
      <!-- Rango de fechas y tipo movimiento -->
      <div class="sm:col-span-2 lg:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-calendar-range"></i>
          Rango de fechas
        </label>
        <div
          class="flex items-center rounded-lg border border-slate-200 bg-white transition-all duration-150 focus-within:ring-2 focus-within:ring-accent-500/20 focus-within:border-accent-500 hover:border-slate-300"
        >
          <span class="flex items-center justify-center pl-3 pr-2 text-slate-400 shrink-0">
            <i class="bi bi-calendar text-sm"></i>
          </span>
          <app-datepicker
            ngSkipHydration
            class="flex-1"
            [borderless]="true"
            [formField]="$any(formFiltro.rangoFecha)"
            selectionMode="range"
            [maxDate]="maxDate"
            placeholder="Seleccione un rango"
            dateFormat="dd/mm/yy"
            [minDate]="minDate"
            [showButtonBar]="true"
            [invalid]="formFiltro.rangoFecha().touched() && formFiltro.rangoFecha().invalid()"
          />
        </div>
        @if (formFiltro.rangoFecha().touched() && formFiltro.rangoFecha().invalid()) {
          <small class="text-sm text-red-600">{{
            formFiltro.rangoFecha().errors() | formErrorMessage
          }}</small>
        }
      </div>
      <!-- Tipo de estado -->
      <div class="sm:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-arrow-left-right"></i>
          Estado Venta
        </label>
        <app-select
          class="w-full"
          [options]="opcionesEstado()"
          [formField]="$any(formFiltro.estado)"
          placeholder="Seleccione un estado"
        />
      </div>
      <!-- Tipo de documento -->
      <div class="sm:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-arrow-left-right"></i>
          Tipo Documento
        </label>
        <app-select
          class="w-full"
          [options]="opcionesTipoDocumentoSunat()"
          [formField]="$any(formFiltro.tipo_documento_sunat)"
          placeholder="Seleccione un estado"
        />
      </div>
      <!-- Usuario -->
      <div class="sm:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-person-circle"></i>
          Empleado
        </label>
        <app-select
          class="w-full"
          [options]="opcionesEmpleado()"
          [formField]="$any(formFiltro.empleado)"
          [filter]="opcionesEmpleado().length > 10"
          filterBy="label"
          emptyFilterMessage="No se encontraron empleados."
          [loading]="!opcionesEmpleado().length"
          placeholder="Seleccione un empleado"
        />
      </div>
      <!-- cliente -->
      <app-buscador-cliente
        [(cliente)]="formFiltro().controlValue().cliente"
        [mostar_creador]="false"
      />
      <!-- sucursal -->
      <div class="sm:col-span-2 lg:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-geo-alt"></i>
          Sucursal
        </label>
        <app-select
          class="w-full"
          [options]="opcionesSucursal()"
          [formField]="$any(formFiltro.sucursal)"
          [filter]="opcionesSucursal().length > 10"
          filterBy="label"
          emptyFilterMessage="No se encontraron sucursales."
          [loading]="!opcionesSucursal().length"
          placeholder="Seleccione una sucursal"
        />
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        <!-- Numero de serie -->
        <div>
          <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
            <i class="bi bi-file-earmark-text"></i>
            Serie Documento
          </label>
          <input
            type="text"
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            [class.border-red-500]="
              formFiltro.serie_documento().touched() && formFiltro.serie_documento().invalid()
            "
            placeholder="Ingrese la serie del documento"
            [formField]="$any(formFiltro.serie_documento)"
          />
          @if (formFiltro.serie_documento().touched() && formFiltro.serie_documento().invalid()) {
            <small class="text-sm text-red-600">{{
              formFiltro.serie_documento().errors() | formErrorMessage
            }}</small>
          }
        </div>
        <!-- Numero de documento -->
        <div>
          <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
            <i class="bi bi-file-earmark-text"></i>
            N° Documento
          </label>
          <app-input-number
            class="w-full"
            placeholder="Ingrese el número del documento"
            [formField]="$any(formFiltro.numero_documento)"
          />
          @if (formFiltro.numero_documento().touched() && formFiltro.numero_documento().invalid()) {
            <small class="text-sm text-red-600">{{
              formFiltro.numero_documento().errors() | formErrorMessage
            }}</small>
          }
        </div>
      </div>
    </div>

    <!-- Botones de acción -->
    <div class="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-3 gap-2 sm:gap-3">
      <button
        type="submit"
        class="px-3 sm:px-4 py-2 sm:py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm"
      >
        <i class="bi bi-search"></i>
        <span class="hidden sm:inline">Buscar</span>
      </button>
      <button
        type="button"
        (click)="limpiarFiltros()"
        class="px-3 sm:px-4 py-2 sm:py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors flex items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm"
      >
        <i class="bi bi-arrow-clockwise"></i>
        <span class="hidden sm:inline">Limpiar</span>
      </button>
      <button
        type="button"
        (click)="exportarExcel()"
        class="px-3 sm:px-4 py-2 sm:py-2.5 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors flex items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm"
      >
        <i class="bi bi-file-earmark-excel"></i>
        <span class="hidden sm:inline">Excel</span>
      </button>
    </div>
  </form>
</app-filtros-reporte>
<app-tabla
  titulo="Reporte de ventas"
  [columnas]="columnasTabla"
  [datos]="paginacion()?.data || []"
  [accionesTemplate]="accionesTemplate"
/>
<ng-template #columnaEstadoTemplate let-row>
  <app-tag
    [value]="row.estado"
    [severity]="colorEstadoTemplate(row.estado)"
    [appTooltip]="row.observaciones || null"
    tooltipPosition="top"
  />
</ng-template>
<!-- sucursal -->
<ng-template #sucursalColumnTemplate let-row>
  {{ row.sucursal_id | nombreSucursal }}
</ng-template>
<ng-template #accionesTemplate let-row>
  <div class="flex flex-col md:flex-row gap-2">
    <button
      type="button"
      class="text-blue-600 hover:text-blue-800 font-medium text-sm inline-flex items-center gap-1 transition-colors"
      (click)="verReporteVenta(row)"
    >
      <i class="bi bi-eye"></i>
      <span class="hidden sm:inline">Ver</span>
    </button>
    <!-- descargar/imprimir pdf -->
    <button
      type="button"
      class="text-purple-600 hover:text-purple-800 font-medium text-sm inline-flex items-center gap-1 transition-colors disabled:opacity-50"
      (click)="descargarOImprimirPdf(row)"
      [disabled]="descargandoPdf()"
      title="Descargar o imprimir PDF de la venta"
    >
      @if (descargandoPdf()) {
        <i class="bi bi-arrow-repeat animate-spin"></i>
      } @else {
        <i class="bi bi-file-pdf"></i>
      }
      <span class="hidden sm:inline">PDF</span>
    </button>
    <!-- reemitir -->
    @if (row.estado == EEstadoVenta.SUNAT_AUTORIZADO_REEMISION) {
      <button
        type="button"
        class="text-green-600 hover:text-green-800 font-medium text-sm inline-flex items-center gap-1 transition-colors disabled:opacity-50"
        (click)="reemitirVenta(row)"
        [disabled]="reemitiendoVenta()"
      >
        @if (reemitiendoVenta()) {
          <i class="bi bi-arrow-repeat animate-spin"></i>
        } @else {
          <i class="adri adri-sunat"></i>
        }
        <span class="hidden sm:inline">Reemitir</span>
      </button>
    }
    <!-- anular -->
    <button
      type="button"
      class="text-red-600 hover:text-red-800 font-medium text-sm inline-flex items-center gap-1 transition-colors disabled:opacity-50"
      (click)="anularVenta(row)"
      [disabled]="
        row.estado == EEstadoVenta.ANULADO ||
        row.estado == EEstadoVenta.SUNAT_PENDIENTE_ANULACION ||
        row.estado == EEstadoVenta.SUNAT_PENDIENTE
      "
    >
      <i class="bi bi-x-circle"></i>
      <span class="hidden sm:inline">Anular</span>
    </button>
  </div>
</ng-template>
<app-dialog
  header="Confirmar anulación de venta"
  [(visible)]="modal_confirmar_anular_venta"
  [modal]="true"
  size="sm"
  [closable]="true"
  (onHide)="modal_confirmar_anular_venta.set(false); anulandoVenta.set(false)"
>
  <app-modal-confirmacion
    mensaje="¿Estás seguro que deseas anular la venta? <br/> Si estas seguro ¿Cual sería el motivo de la anulación?."
    [showInput]="true"
    [loading]="anulandoVenta()"
    textoCancel="Cancelar"
    textoConfirm="Si, anular"
    (confirmar)="confirmarAnularVenta($event)"
    (cancelar)="
      this.reporte_venta_seleccionada.set(null);
      modal_confirmar_anular_venta.set(false);
      anulandoVenta.set(false)
    "
  />
</app-dialog>
@if (paginacion() !== null) {
  <app-paginacion
    [items]="paginacion()!.data"
    [itemsPorPagina]="paginacion()!.size"
    [totalItems]="paginacion()!.total"
    (paginaCambiada)="cambiarPagina($event)"
  />
}

<app-dialog
  header="Detalle de la venta"
  [(visible)]="modal_ver_venta"
  [modal]="true"
  size="2xl"
  styleClass="w-full sm:max-w-4xl max-h-[95vh]"
  [closable]="true"
  (onHide)="onModalVentaClose()"
>
  @if (modal_ver_venta() == true && reporte_venta_seleccionada() != null) {
    <div class="space-y-4">
      <!-- Header con ID, Estado y Acción -->
      <div class="from-blue-50 to-blue-100 rounded-lg p-3 sm:p-4">
        <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
          <div class="flex flex-wrap items-center gap-x-4 gap-y-2">
            <div>
              <p class="text-xs text-gray-600 mb-1">ID Venta</p>
              <p class="text-xl sm:text-2xl font-bold text-gray-900">
                #{{ reporte_venta_seleccionada()!.id }}
              </p>
            </div>
            <div class="hidden sm:block h-10 w-px bg-gray-300"></div>
            <div>
              <p class="text-xs text-gray-600 mb-1">Estado</p>
              <app-tag
                [value]="reporte_venta_seleccionada()!.estado"
                [severity]="colorEstadoTemplate(reporte_venta_seleccionada()!.estado)"
              />
            </div>
            <div class="hidden sm:block h-10 w-px bg-gray-300"></div>
            <div>
              <p class="text-xs text-gray-600 mb-1">Fecha</p>
              <p class="text-xs sm:text-sm font-semibold text-gray-900">
                {{ reporte_venta_seleccionada()!.created_at | date: 'dd/MM/yyyy HH:mm' }}
              </p>
            </div>
          </div>
          <app-button
            label="Ver productos"
            icon="bi bi-box-seam"
            variant="info"
            size="sm"
            class="w-full sm:w-auto"
            (onClick)="verDetalleVenta()"
          />
        </div>
      </div>

      <!-- Grid de 2 columnas para optimizar espacio -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        <!-- Documento -->
        <div class="bg-white border border-gray-200 rounded-lg p-3 sm:p-4">
          <h3 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
            <i class="bi bi-file-earmark-text text-blue-600"></i>
            Documento
          </h3>
          <div class="space-y-2">
            <div class="flex justify-between">
              <span class="text-xs text-gray-600">Tipo:</span>
              <span class="text-sm font-medium text-gray-900">
                {{ reporte_venta_seleccionada()!.tipo_documento_sunat }}
              </span>
            </div>
            <div class="flex justify-between">
              <span class="text-xs text-gray-600">Serie:</span>
              <span class="text-sm font-medium text-gray-900">
                {{ reporte_venta_seleccionada()!.serie_documento }}
              </span>
            </div>
            <div class="flex justify-between">
              <span class="text-xs text-gray-600">Correlativo:</span>
              <span class="text-sm font-medium text-gray-900">
                {{ reporte_venta_seleccionada()!.correlativo_documento }}
              </span>
            </div>
            <div class="flex justify-between pt-2 border-t border-gray-200">
              <span class="text-xs text-gray-600">Turno/Caja:</span>
              <span class="text-sm font-medium text-gray-900">
                {{ reporte_venta_seleccionada()!.caja_turno_id }}
              </span>
            </div>
            <div class="flex justify-between pt-2 border-t border-gray-200">
              <span class="text-xs text-gray-600">Respuesta SUNAT:</span>
              <span
                class="text-sm font-medium text-gray-900 break-words [&>a]:inline-block [&>a]:whitespace-nowrap"
                [innerHTML]="reporte_venta_seleccionada()!.respuesta_sunat | sunatRespuesta"
              >
              </span>
              <!-- <span class="text-red-600">{{ reporte_venta_seleccionada()!.respuesta_sunat }}</span> -->
            </div>
          </div>
        </div>

        <!-- Empleado -->
        <div class="bg-white border border-gray-200 rounded-lg p-3 sm:p-4">
          <h3 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
            <i class="bi bi-person-badge text-blue-600"></i>
            Empleado
          </h3>
          <div class="space-y-2">
            <div>
              <p class="text-xs text-gray-600">Nombre</p>
              <p class="text-sm font-medium text-gray-900">
                {{ reporte_venta_seleccionada()!.usuario_nombre_completo }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-600">Email</p>
              <p class="text-sm font-medium text-gray-900">
                {{ reporte_venta_seleccionada()!.usuario_email }}
              </p>
            </div>
          </div>
        </div>

        <!-- Cliente -->
        <div class="bg-white border border-gray-200 rounded-lg p-3 sm:p-4">
          <h3 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
            <i class="bi bi-person-circle text-blue-600"></i>
            Cliente
          </h3>
          <div class="space-y-2">
            <div>
              <p class="text-xs text-gray-600">Nombre</p>
              <p class="text-sm font-medium text-gray-900">
                {{ reporte_venta_seleccionada()!.cliente_nombre_completo || 'Cliente genérico' }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-600">DNI</p>
              <p class="text-sm font-medium text-gray-900">
                {{ reporte_venta_seleccionada()!.cliente_dni || 'No especificado' }}
              </p>
            </div>
          </div>
        </div>

        <!-- Montos -->
        <div class="bg-white border border-gray-200 rounded-lg p-3 sm:p-4">
          <h3 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
            <i class="bi bi-cash-coin text-blue-600"></i>
            Montos
          </h3>
          <div class="space-y-2">
            <div class="flex justify-between items-center">
              <span class="text-xs text-gray-600">Subtotal</span>
              <span class="text-sm font-medium text-gray-900">
                {{
                  reporte_venta_seleccionada()!.total - reporte_venta_seleccionada()!.descuento
                    | currency: 'PEN' : 'S/ '
                }}
              </span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-xs text-gray-600">Descuento</span>
              <span class="text-sm font-medium text-red-600">
                -{{ reporte_venta_seleccionada()!.descuento | currency: 'PEN' : 'S/ ' }}
              </span>
            </div>
            <div
              class="flex justify-between items-center pt-2 mt-2 border-t-2 border-blue-200"
            >
              <span class="text-sm font-semibold text-gray-800">Total</span>
              <span class="text-base sm:text-lg font-bold text-blue-600">
                {{ reporte_venta_seleccionada()!.total | currency: 'PEN' : 'S/ ' }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Observaciones (full width si existen) -->
      @if (reporte_venta_seleccionada()!.observaciones) {
        <div class="bg-amber-50 border border-amber-200 rounded-lg p-4">
          <h3 class="text-sm font-semibold text-amber-800 mb-2 flex items-center gap-2">
            <i class="bi bi-chat-left-text"></i>
            Observaciones
          </h3>
          <p class="text-sm text-amber-900">{{ reporte_venta_seleccionada()!.observaciones }}</p>
        </div>
      }

      <!-- Trazabilidad SUNAT (si hay error o reintentos) -->
      @if (
        reporte_venta_seleccionada()!.ultimo_error_sunat ||
        reporte_venta_seleccionada()!.cantidad_reintentos_sunat
      ) {
        <div class="bg-slate-50 border border-slate-200 rounded-lg p-4">
          <h3 class="text-sm font-semibold text-slate-700 mb-2 flex items-center gap-2">
            <i class="bi bi-arrow-repeat"></i>
            Trazabilidad SUNAT
          </h3>
          <div class="space-y-1 text-sm text-slate-600">
            @if (reporte_venta_seleccionada()!.cantidad_reintentos_sunat) {
              <p>
                <span class="font-medium">Reintentos:</span>
                {{ reporte_venta_seleccionada()!.cantidad_reintentos_sunat }}
              </p>
            }
            @if (reporte_venta_seleccionada()!.fecha_ultimo_intento_sunat) {
              <p>
                <span class="font-medium">Último intento:</span>
                {{
                  reporte_venta_seleccionada()!.fecha_ultimo_intento_sunat
                    | date: 'dd/MM/yyyy HH:mm'
                }}
              </p>
            }
            @if (reporte_venta_seleccionada()!.ultimo_error_sunat) {
              <p>
                <span class="font-medium">Último error:</span>
                {{ reporte_venta_seleccionada()!.ultimo_error_sunat }}
              </p>
            }
          </div>
        </div>
      }
      <app-ver-venta #verVentaComponent />
    </div>
  }
</app-dialog>
